module.exports = function getResource(label, vars = []) {
    let resources = {
        relatedContentLabel: 'Contenu relié :'
    };
    return resources[label];
};
